import React from 'react';
import { connect } from 'react-redux';

import { onValueChange } from '../reducer';

import get from "lodash.get";
import * as validationHelper from "../../../helpers/validationHelper";

import { Form, Checkbox } from 'semantic-ui-react';
import DropdownField from '../../../components/common/formElements/dropdownField';
import CInputField from '../../../components/common/formElements/cInputField';
import EmailField from '../../../components/common/formElements/emailField';
import CheckboxField from '../../../components/common/formElements/checkboxField';
import FormbuilderAddress from '../../../components/common/formbuilderFields/formbuilderAddress';
import FormbuilderPhoneNumber from '../../../components/common/formbuilderFields/formbuilderPhoneNumber';

import { paths, fieldsValidation, recurringFieldsValidation, recurringCustomFieldsValidation } from '../constants';
import { salutationOptions } from '../../../constants/salutation';
import { tabs } from '../constants/tabs';
import { MAX_COMPANY_NAME_LENGTH } from '../../../constants/index';

class RecurringDetailsTabContainer extends React.Component {
    componentDidMount() {
        this.validate();
    }

    componentDidUpdate() {
        this.validate();
    }

    onChange = (path, value) => {
        this.props.onValueChange(path, value);
    }

    getValidationModels = (props) => {
        const customFieldsValidation = this.getCustomFieldsValidation();

        const allFields = { ...recurringFieldsValidation, ...customFieldsValidation };
        const validationModels = Object.keys(allFields).map(item => {
            const validation = allFields[item];
            return {
                validationModel: validation,
                value: get(props.donation, validation.path)
            }
        });

        return validationModels;
    }

    getCustomFieldsValidation = () => {
        const showSalutation = get(this.props.customFields, 'salutation.enabled');
        const showAddress = get(this.props.customFields, 'address.enabled');
        const showPhoneNumber = get(this.props.customFields, 'phoneNumber.enabled');

        const salutationValidation = {
            ...recurringCustomFieldsValidation.SALUTATION,
            required: showSalutation && get(this.props.customFields, 'salutation.required')
        };
        const addressValidation = {
            ...recurringCustomFieldsValidation.ADDRESS,
            required: showAddress && get(this.props.customFields, 'address.required'),
            formbuilderAddressRequired: showAddress && get(this.props.customFields, 'address.required')
        };
        const phoneNumberValidation = {
            ...recurringCustomFieldsValidation.PHONE_NUMBER,
            required: showPhoneNumber && get(this.props.customFields, 'phoneNumber.required'),
        };

        return {
            salutation: salutationValidation,
            address: addressValidation,
            phoneNumber: phoneNumberValidation
        }
    };

    validate = () => {
        const validationModels = this.getValidationModels(this.props);
        const isAllFieldsValid = validationHelper.isAllFieldsValid(validationModels);

        if (this.props.isTabValid !== isAllFieldsValid) {
            this.onChange(paths.IS_DETAILS_TAB_VALID, isAllFieldsValid);
        }
    };

    onBehalfOfCompanyChange = (value) => {
        this.props.onValueChange(paths.IS_BEHALF_OF_COMPANY, value)
        if (!value) {
            this.props.onValueChange(paths.BUSINESS_NAME, null)
        }
    }

    render() {
        const { customer, address, phoneNumber } = this.props.donation;
        const { firstName, lastName, email, businessName, newsletter, isBehalfOfCompany, salutation } = customer;

        const showSalutation = get(this.props.customFields, 'salutation.enabled');
        const showAddress = get(this.props.customFields, 'address.enabled');
        const showPhoneNumber = get(this.props.customFields, 'phoneNumber.enabled');

        const customFieldsValidation = this.getCustomFieldsValidation();

        const hideNewsLetterCheckbox = this.props.newsletter && this.props.newsletter.hide && this.props.newsletter.pages.some(item => item === "donation");

        return (
            <div className="user-stats-cont">
                <Form>
                    {
                        showSalutation &&
                        <DropdownField
                            label="Salutation"
                            id="Salutation"
                            value={salutation}
                            options={salutationOptions}
                            onChange={(event, { value }) => this.onChange(paths.SALUTATION, value)}
                            validation={customFieldsValidation.salutation} />
                    }

                    <CInputField label="First name"
                        id="firstName"
                        value={firstName}
                        onChange={(event, { value }) => this.onChange(paths.FIRST_NAME, value)}
                        validation={fieldsValidation.FIRST_NAME} />

                    <CInputField label="Last name"
                        id="lastName"
                        value={lastName}
                        validation={fieldsValidation.LAST_NAME}
                        onChange={(event, { value }) => this.onChange(paths.LAST_NAME, value)} />

                    <EmailField value={email}
                        label="Email"
                        id="email"
                        validation={fieldsValidation.EMAIL}
                        onChange={(value) => this.onChange(paths.EMAIL, value)} />

                    {
                        showAddress &&
                        <FormbuilderAddress
                            onChange={this.onChange.bind(this, paths.ADDRESS)}
                            label="Address"
                            value={address}
                            validation={customFieldsValidation.address}
                            initialValidation={false}
                        />
                    }

                    {
                        showPhoneNumber &&
                        <FormbuilderPhoneNumber
                            onChange={this.onChange.bind(this, paths.PHONE_NUMBER)}
                            label="Phone Number"
                            value={phoneNumber}
                            validation={customFieldsValidation.phoneNumber}
                            organizationCountry={this.props.organizationCountry}
                        />
                    }

                    <Form.Field>
                        <Checkbox checked={isBehalfOfCompany}
                            onChange={(event, { checked }) => this.onBehalfOfCompanyChange(checked)}
                            label="I'm donating on behalf of a company" />
                    </Form.Field>

                    <CInputField label="Company name"
                        value={businessName}
                        hidden={!isBehalfOfCompany}
                        onChange={(event, { value }) => this.onChange(paths.BUSINESS_NAME, value)}
                        maxLength={MAX_COMPANY_NAME_LENGTH} />

                    {
                        !hideNewsLetterCheckbox &&
                        <CheckboxField
                            inputLabel={`I'd like to receive updates from ${this.props.organizationName}`}
                            checked={newsletter}
                            onChange={(event, { checked }) => this.onChange(paths.RECEIVE_NEWS_LETTER, checked)}
                        />
                    }
                </Form>
            </div>
        );
    }
}

const mapState = state => {
    return {
        donation: state.donation,
        isTabValid: state.donation.tabsValidation[tabs.DETAILS],

        organizationName: get(state, 'page.campaign.organization.name'),
        organizationCountry: get(state, 'page.campaign.organization.country'),
        campaignType: get(state, 'page.campaign.type'),

        newsletter: get(state, "page.campaign.template.value.customSetup.newsletter"),
        customFields: get(state, 'page.campaign.template.value.recurringSetup.customFields')
    }
}

const mapDispatch = (dispatch) => {
    return {
        onValueChange(path, value) {
            dispatch(onValueChange(path, value))
        }
    }
}

const RecurringDetailsTab = connect(mapState, mapDispatch)(RecurringDetailsTabContainer);
export default RecurringDetailsTab;
